
class ReportScriptFilterView extends MUIView
{
    awakeFromHTML(){

    }
}